import { CircularProgress } from "@mui/material";
import { useTheme, Box } from "@mui/material";
import { getLoaderStyle } from "./customstyles/LoaderStyle";

const useStyles = () => {
  let theme = useTheme();
  return getLoaderStyle(theme);
};

function Loader(props) {
  const classes = useStyles();
  return (
    <Box component="div" sx={classes.commonLoader}>
      <CircularProgress />
    </Box>
  );
}

export default Loader;
